import { beHttp } from './beHttp';
import { CertificationServiceCode, CertificationValidationResult } from '../../types/certificationValidation';

/**
 * Validación IA de certificados de servicios (Pareja/Familia/Orientación
 * Vocacional) — endpoint productivo en psiplatform-be. Reemplaza al webhook
 * externo (n8n) y al server local de desarrollo que existieron antes acá
 * (ver el módulo `certification-validation` en psiplatform-be para el system
 * prompt y el contrato completo).
 *
 * Va por `beHttp` como cualquier otra llamada de psiplatform-fe a
 * psiplatform-be: mismo Bearer de la sesión de la psicóloga, sin `x-api-key`.
 */
export interface ValidateServiceCertificationParams {
  service: CertificationServiceCode;
  attempt: 1 | 2 | 3;
  certificateFile: File;
  additionalDocumentFile?: File | null;
}

export async function validateServiceCertification(
  params: ValidateServiceCertificationParams,
): Promise<CertificationValidationResult> {
  const form = new FormData();
  form.append('service', params.service);
  form.append('attempt', String(params.attempt));
  form.append('certificate', params.certificateFile);
  if (params.additionalDocumentFile) form.append('additionalDocument', params.additionalDocumentFile);
  // No se manda `psychologistName`: el backend lo deriva del token de la sesión
  // autenticada (no confía en un valor que el cliente podría manipular para el
  // chequeo de titularidad del prompt).

  return beHttp.post<CertificationValidationResult>(
    '/api/psychologist/certification-validation',
    form,
    // El error se muestra inline en el panel de validación (ver
    // ValidationResultPanel / certState.error) — no hace falta un toast también.
    { showErrorToast: false },
  );
}
